showLikedList = ($target) ->
  return false if $target.find('.popover-liked-list').length

  xhr = $.ajax
    url: $target.data('liked-list-url')
    type: 'get'
    dataType: 'json'
    success: (result) ->
      return false unless result.success

      $popover = $ result.html
      $target.find('.count').text result.count
      $('.popover-liked-list').fadeOut 'fast', -> $(@).remove()

      $popover.find('.liked-list').css
        width: if result.count < 5 then result.count * 40 else 206

      $popover.appendTo $target
        .css
          top: 0 - ($popover.height() + 10)
          left: $target.outerWidth() / 2 - $popover.width() / 2
        .fadeIn 'fast'

      if result.count * 1 > 10
        $popover.find('.liked-list').addClass 'scroll'

      $target.one 'mouseleave', ->
        $popover.fadeOut 'fast', -> $(@).remove()
    complete: -> xhr = null

$ ->
  likeTimeout = null

  $(document)
    .on 'click', '.link-like', (e) ->
      $link = $ e.currentTarget
      unless $link.hasClass('i-liked')
        $link.addClass 'loading'
        setTimeout ->
          $link.removeClass 'loading'
        , 1000
    .on 'ajax:success', '.link-like', (e, result) ->
      if result.success
        $link = $ e.currentTarget
        count = result.count
        liked = true
        iliked = true
        
        $link.find('.popover-liked-list').fadeOut 'fast', ->
          $(@).remove()

        if $link.hasClass('i-liked')
          url = $link.attr('href').replace '/unlike', '/like'
          iliked = false

          unless result.count
            liked = false
            count = ''
        else
          url = $link.attr('href').replace '/like', '/unlike'

        $link.toggleClass 'i-liked', iliked
          .toggleClass 'liked', liked
          .attr 'href', url
          .find('.count').text count
    .on 'mouseover', '.link-like.liked:not(.loading)', (e) ->
      likeTimeout = setTimeout ->
        showLikedList $(e.currentTarget)
      , 1000
    .on 'mouseout', '.link-like', ->
      clearTimeout likeTimeout

  $('.link-like').on 'click', '.popover-liked-list', (e) ->
    if $(e.target).closest('.popover-liked-list').length
      e.stopPropagation()